
import { ISearchComponentsPaginatedParameters } from "./ISearchComponentsPaginatedParameters";


export class SearchComponentsPaginatedParameters implements ISearchComponentsPaginatedParameters
{
    companyId: number = 0;
    text: string = "";
    flags: number = 0;
    onlyOffline: boolean  = false;
    sortBy: string = "";
    sortOrder: number = 0;
    pageSize: number = 0;
    pageNumber: number = 0;
}
